<template>
  <div class="home-container">
    <!-- 头部 -->
    <div class="header"></div>
    <!-- 背景图 -->
    <div class="chart-bg"></div>
    <!-- 全屏 -->
    <div class="screen-btn" @click="toggleScreenfull" v-show="!iframe">
      <img v-if="!fullscreen" src="../../assets/images/icon_fullscreen.png" alt="">
      <img v-else src="../../assets/images/icon_fullscreen_exit.png" alt="">
    </div>
    <!-- 返回 -->
    <div class="return-btn" @click="handleBack" v-show="!iframe">
      <img src="../../assets/images/icon_return.png" alt="">
    </div>
    <!-- 弹出层 -->
    <div class="popup" v-if="alarm.show">
      <div class="popup-box">
        <div class="popup-header">
          <div class="title">{{alarm.name}}</div>
          <div class="close-btn" @click="closeAlarmList"></div>
        </div>
        <div class="popup-body">
          <div class="">
            <el-table
              :data="alarm.list.slice((currentPage-1)*pagesize,currentPage*pagesize)"
              height="495"
              border
              style="width: 100%">
              <el-table-column
                prop="Severity"
                label="告警級別"
                align="center"
                width="110">
                <template slot-scope="scope">
                  <img v-if="scope.row.Severity == 0" width="20" height="20" src="../../assets/images/icon_urgency_f.png"  />
                  <img v-if="scope.row.Severity == 1" width="20" height="20" src="../../assets/images/icon_urgency_e.png"  />
                  <img v-if="scope.row.Severity == 2" width="20" height="20" src="../../assets/images/icon_urgency_d.png"  />
                  <img v-if="scope.row.Severity == 3" width="20" height="20" src="../../assets/images/icon_urgency_c.png"  />
                  <img v-if="scope.row.Severity == 4" width="20" height="20" src="../../assets/images/icon_urgency_b.png"  />
                  <img v-if="scope.row.Severity == 5" width="20" height="20" src="../../assets/images/icon_urgency_a.png"  />
                </template>
              </el-table-column>
              <el-table-column
                prop="node"
                label="設備名稱"
                width="195">
              </el-table-column>
              <el-table-column
                prop="NodeAlias"
                label="設備位址"
                width="145">
              </el-table-column>
              <el-table-column
                prop="Summary"
                label="告警詳情">
              </el-table-column>
              <el-table-column
                prop="LastOccurrence"
                label="最近發生時間"
                width="175">
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pagesize"
              layout="prev, pager, next, jumper"
              :total="alarm.list.length">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 主要内容 -->
    <div class="main">
      <!-- 遮罩层 -->
      <div class="modal" v-show="showModal"></div>
      <!-- 线 -->
      <div class="line" :class="{'animation': addAnimation}">
        <Line-Charts :option="lineOption"></Line-Charts>
      </div>
      <div class="box-class1">
        <div class="box-class-wapper">
          <div class="box-title">
            <img src="../../assets/images/img_platform_name_c.png" alt="">
          </div>
          <div class="list">
            <!-- <div class="item" v-if="data['APP002']" :class="{'alarmlevel3': showlevel3}">
              <div class="title"><div class="title-name">{{data['APP002'].name}}</div></div>
              <div class="svga rectangle-big">
                <svga class="svga-level0" v-show="!showlevel3" src="./svga/icon_basics_a_b.svga" :options="options" />
                <svga class="svga-level3" v-show="showlevel3" src="./svga/icon_basics_a_y.svga" :options="options" />
              </div>
            </div> -->
            <app-modules :hasRelation="hasRelation('APP002')" :noRelation="noRelation('APP002')" v-if="data['APP002']" :app="data['APP002'] || {}" base="rectangle-big" svga="icon_basics_a"></app-modules>
            <app-modules :hasRelation="hasRelation('APP007')" :noRelation="noRelation('APP007')" v-if="data['APP007']" :app="data['APP007'] || {}" base="rectangle-small" svga="icon_basics_b"></app-modules>
            <app-modules :hasRelation="hasRelation('APP006')" :noRelation="noRelation('APP006')" v-if="data['APP006']" :app="data['APP006'] || {}" base="rectangle-big" svga="icon_basics_c"></app-modules>
          </div>
        </div>
      </div>
      <div class="box-link1">
        <svga src="./svga/icon_arrow.svga" :options="options" />
      </div>
      <div class="box-class2">
        <div class="box-class-wapper">
          <div class="box-title">
            <img src="../../assets/images/img_platform_name_b.png" alt="">
          </div>
          <div class="list-box">
            <div class="list-item">
              <div class="list-classify">
                <img src="../../assets/images/img_classification_a.png" alt="">
              </div>
              <div class="item-gathers">
                <div class="item-gather">
                  <div class="item-gather-name"><div class="text">智慧治安</div></div>
                  <div class="list">
                    <app-modules :hasRelation="hasRelation('APP010')" :noRelation="noRelation('APP010')" v-if="data['APP010']" :app="data['APP010'] || {}" base="square-small" svga="icon_application_h"></app-modules>
                    <app-modules :hasRelation="hasRelation('APP018')" :noRelation="noRelation('APP018')" v-if="data['APP018']" :app="data['APP018'] || {}" base="square-small" svga="icon_application_i"></app-modules>
                  </div>
                </div>
                <div class="item-gather">
                  <div class="item-gather-name"><div class="text">智慧高校</div></div>
                  <div class="list has-one">
                    <app-modules :hasRelation="hasRelation('APP017')" :noRelation="noRelation('APP017')" v-if="data['APP017']" :app="data['APP017'] || {}" base="square-small" svga="icon_application_j"></app-modules>
                  </div>
                </div>
                <div class="item-gather">
                  <div class="item-gather-name"><div class="text">智慧保障</div></div>
                  <div class="list big">
                    <app-modules :hasRelation="hasRelation('APP012')" :noRelation="noRelation('APP012')" v-if="data['APP012']" :app="data['APP012'] || {}" base="square-big" svga="icon_application_k"></app-modules>
                    <app-modules :hasRelation="hasRelation('APP011')" :noRelation="noRelation('APP011')" v-if="data['APP011']" :app="data['APP011'] || {}" base="square-small" svga="icon_application_l"></app-modules>
                  </div>
                </div>
                <div class="item-gather">
                  <div class="item-gather-name"><div class="text">智慧消防</div></div>
                  <div class="list has-one">
                    <app-modules :hasRelation="hasRelation('APP013')" :noRelation="noRelation('APP013')" v-if="data['APP013']" :app="data['APP013'] || {}" base="square-small" svga="icon_application_m"></app-modules>
                  </div>
                </div>
                <div class="item-gather">
                  <div class="item-gather-name"><div class="text">智慧司法</div></div>
                  <div class="list has-one">
                    <app-modules :hasRelation="hasRelation('APP015')" :noRelation="noRelation('APP015')" v-if="data['APP015']" :app="data['APP015'] || {}" base="square-small" svga="icon_application_n"></app-modules>
                  </div>
                </div>
              </div>
            </div>
            <div class="list-item">
              <div class="list-classify">
                <img src="../../assets/images/img_classification_b.png" alt="">
              </div>
              <div class="item-gathers">
                <div class="item-gather">
                  <div class="item-gather-name"><div class="text">智慧保障</div></div>
                  <div class="list has-five">
                    <app-modules :hasRelation="hasRelation('APP016')" :noRelation="noRelation('APP016')" v-if="data['APP016']" :app="data['APP016'] || {}" base="square-small" svga="icon_application_a"></app-modules>
                    <app-modules :hasRelation="hasRelation('APP005')" :noRelation="noRelation('APP005')" v-if="data['APP005']" :app="data['APP005'] || {}" base="square-small" svga="icon_application_b"></app-modules>
                    <app-modules :hasRelation="hasRelation('APP004')" :noRelation="noRelation('APP004')" v-if="data['APP004']" :app="data['APP004'] || {}" base="square-small" svga="icon_application_c"></app-modules>
                    <app-modules :hasRelation="hasRelation('APP003')" :noRelation="noRelation('APP003')" v-if="data['APP003']" :app="data['APP003'] || {}" base="square-big" svga="icon_application_d"></app-modules>
                    <app-modules :hasRelation="hasRelation('APP019')" :noRelation="noRelation('APP019')" v-if="data['APP019']" :app="data['APP019'] || {}" base="square-big" svga="icon_application_e"></app-modules>
                  </div>
                </div>
                <div class="item-gather">
                  <div class="item-gather-name"><div class="text">智慧民生</div></div>
                  <div class="list has-one big">
                    <app-modules :hasRelation="hasRelation('APP020')" :noRelation="noRelation('APP020')" v-if="data['APP020']" :app="data['APP020'] || {}" base="square-big" svga="icon_application_f"></app-modules>
                  </div>
                </div>
                <div class="item-gather">
                  <div class="item-gather-name"><div class="text">智慧民防</div></div>
                  <div class="list has-one">
                    <app-modules :hasRelation="hasRelation('APP014')" :noRelation="noRelation('APP014')" v-if="data['APP014']" :app="data['APP014'] || {}" base="square-small" svga="icon_application_g"></app-modules>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-link2">
        <svga src="./svga/icon_arrow.svga" :options="options" />
      </div>
      <div class="box-class1 box-class3">
        <div class="box-class-wapper">
          <div class="box-title">
            <img src="../../assets/images/img_platform_name_a.png" alt="">
          </div>
          <div class="list">
            <app-modules :hasRelation="hasRelation('APP021')" :noRelation="noRelation('APP021')" v-if="data['APP021']" :app="data['APP021'] || {}" base="circle-big" svga="icon_gateway_b"></app-modules>
            <app-modules :hasRelation="hasRelation('APP009')" :noRelation="noRelation('APP009')" v-if="data['APP009']" :app="data['APP009'] || {}" base="circle-small" svga="icon_gateway_a"></app-modules>
            <app-modules :hasRelation="hasRelation('APP008')" :noRelation="noRelation('APP008')" v-if="data['APP008']" :app="data['APP008'] || {}" base="circle-big" svga="icon_gateway_c"></app-modules>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import screenfull from 'screenfull'
import AppModules from '../../components/app'
import LineCharts from '../../components/charts'
import lineOption from '../../assets/line/index'
import { estimateColumn, hasRelationOrientation, managePolyline, intersectionArr } from '../../utils/index'
const allLine = require('../../assets/line/coord.json')
export default {
  name: 'home',
  data () {
    return {
      userId: '',
      appGroups: [
        ['APP002', 'APP007', 'APP006'],
        ['APP010', 'APP018', 'APP017', 'APP012', 'APP011', 'APP013', 'APP015'],
        ['APP016', 'APP005', 'APP004', 'APP003', 'APP019', 'APP020', 'APP014'],
        ['APP021', 'APP009', 'APP008']
      ],
      fullscreen: false,
      showModal: false,
      options: {
        loop: 0,
        fillMode: 'forwards',
        playMode: 'forwards',
        startFrame: 0,
        endFrame: 0,
        autoPlay: true
      },
      data: {},
      relationApp: {
        tagrat: '',
        relation: []
      },
      alarm: {
        show: false,
        name: '',
        list: []
      },
      lineOption: {},
      tableData: [],
      pagesize: 10,
      currentPage: 1,
      addAnimation: false,
      iframe: 0 // 是否被框架引用
    }
  },
  components: {
    AppModules,
    LineCharts
  },
  mounted () {
    window.addEventListener('keydown', this.KeyDown, true)// 监听按键事件
  },
  methods: {
    handleBack () {
      const backLink = window.backLink
      let href = window.backLink
      if (backLink.indexOf('userid') > 0) {
        href = backLink
      } else {
        if (backLink.indexOf('?') > 0) {
          href = backLink + '&userid=' + this.userId
        } else {
          href = backLink + '?userid=' + this.userId
        }
      }
      window.location.href = href
    },
    hasRelation (code) {
      if (this.relationApp.tagrat) {
        if (this.relationApp.tagrat === code || this.relationApp.relation.includes(code)) {
          return true
        }
      }
      return false
    },
    noRelation (code) {
      if (this.relationApp.tagrat) {
        if (this.relationApp.tagrat === code) {
          return false
        } else {
          if (!this.relationApp.relation.includes(code) || this.relationApp.relation.length === 0) {
            return true
          }
        }
      }
      return false
    },
    toggleScreenfull () {
      if (!screenfull.isEnabled) { // 如果不允许进入全屏，发出不允许提示
        this.$message({
          message: '浏览器不支持全屏',
          type: 'warning'
        })
        return false
      }
      this.fullscreen = !this.fullscreen
      screenfull.toggle()
    },
    KeyDown (event) {
      if (event.keyCode === 122) {
        this.fullscreen = !this.fullscreen
        event.returnValue = false
        this.toggleScreenfull()
      }
    },
    openAlarmList (alarmlist, name) {
      this.alarm.show = true
      this.alarm.list = alarmlist
      this.alarm.name = name
      this.$nextTick(() => {
        document.getElementsByClassName('el-pagination__jump')[0].childNodes[0].nodeValue = '跳转'
      })
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
    },
    closeAlarmList () {
      this.alarm.show = false
      this.alarm.list = []
    },
    initWebSocket () { // 初始化weosocket
      this.websock = new WebSocket(window.ws)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose

      this.websock.addEventListener('open', () => {
        const data = { code: 100, message: '登陆', userId: this.userId }
        this.websocketsend(JSON.stringify(data))
      })
    },
    getData (data) {
      const allType2 = data.filter(item => parseInt(item.type) === 1)
      const obj = {}
      allType2.forEach(item => {
        obj[item.code] = item
      })
      this.data = obj
    },
    websocketonopen () { // 连接建立之后执行send方法发送数据
      if (this.isClose) {
        const actions = { reset: true }
        this.websocketsend(JSON.stringify(actions))
      }
    },
    websocketonerror () { // 连接建立失败重连
      this.initWebSocket()
    },
    websocketonmessage (e) { // 数据接收
      // const redata = JSON.parse(e.data)
      const redata = {
        code: 8000,
        message: [
          {
            code: 'APP001',
            NodeAlias: '',
            remark: '智能運維：',
            type: '1',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '智能運維',
            Summary: '',
            bmc_identifier: '',
            id: '2000001389',
            org_name: '',
            alarmlevel: 0,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP002',
            NodeAlias: '',
            remark: '一標六實應用系統：',
            type: '1',
            relation: '["code":"APP003","code":"APP012","code":"APP013","code":"APP014","code":"APP016","code":"APP020","code":"APP004","code":"APP005"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '一標六實應用系統',
            Summary: '',
            bmc_identifier: '',
            id: '2000001390',
            org_name: '',
            alarmlevel: 5,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP003',
            NodeAlias: '',
            remark: '視頻聯網系統：',
            type: '1',
            relation: '["code":"APP002","code":"APP012","code":"APP013","code":"APP014","code":"APP021"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '視頻聯網系統',
            Summary: '',
            bmc_identifier: '',
            id: '2000001391',
            org_name: '',
            alarmlevel: 0,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP004',
            NodeAlias: '',
            remark: '全息檔案：',
            type: '1',
            relation: '["code":"APP021","code":"APP007","code":"APP006","code":"APP002","code":"APP008"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '全息檔案',
            Summary: '',
            alarmList: [
              {
                app_vendor: '',
                app_name: '全息檔案',
                node: 'mc-qxda-vm-a006',
                pcs_name: '',
                Identifier: 'mc-qxda-vm-a006zabbixsyslogdsystem.localtimeSystem time is out of sync (diff with Zabbix server > 60s)1',
                NodeAlias: '10.99.17.34',
                Summary: 'System time is out of sync (diff with Zabbix server > 60s), 2021.09.22 10:10:11',
                bmc_identifier: '',
                Severity: '3',
                org_name: '警察總局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-22 10:11:13'
              },
              {
                app_vendor: '',
                app_name: '全息檔案',
                node: 'mc-qxda-vm-a005',
                pcs_name: '',
                Identifier: 'mc-qxda-vm-a005zabbixsyslogdsystem.localtimeSystem time is out of sync (diff with Zabbix server > 60s)1',
                NodeAlias: '10.99.17.33',
                Summary: 'System time is out of sync (diff with Zabbix server > 60s), 2021.09.22 10:09:56',
                bmc_identifier: '',
                Severity: '3',
                org_name: '警察總局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-22 10:10:58'
              },
              {
                app_vendor: '',
                app_name: '全息檔案',
                node: 'mc-qxda-vm-a008',
                pcs_name: '',
                Identifier: 'mc-qxda-vm-a008zabbixsyslogdsystem.localtimeSystem time is out of sync (diff with Zabbix server > 60s)1',
                NodeAlias: '10.99.17.36',
                Summary: 'System time is out of sync (diff with Zabbix server > 60s), 2021.09.22 10:09:25',
                bmc_identifier: '',
                Severity: '3',
                org_name: '警察總局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-22 10:10:28'
              }
            ],
            bmc_identifier: '',
            id: '2000001392',
            org_name: '',
            alarmlevel: 3,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP005',
            NodeAlias: '',
            remark: '全息預警：',
            type: '1',
            relation: '["code":"APP021","code":"APP007","code":"APP006","code":"APP002","code":"APP008"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '全息預警',
            Summary: '',
            bmc_identifier: '',
            id: '2000001393',
            org_name: '',
            alarmlevel: 0,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP006',
            NodeAlias: '',
            remark: '資源服務平臺：',
            type: '1',
            relation: '["code":"APP021","code":"APP007","code":"APP016","code":"APP004","code":"APP005","code":"APP015","code":"APP008"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '資源服務平臺',
            Summary: '',
            bmc_identifier: '',
            id: '2000001394',
            org_name: '',
            alarmlevel: 0,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP007',
            NodeAlias: '',
            remark: '警務操作日誌審計監督系統：',
            type: '1',
            relation: '["code":"APP021","code":"APP016","code":"APP004","code":"APP005","code":"APP015","code":"APP006","code":"APP012","code":"APP013","code":"APP014","code":"APP020","code":"APP008"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '警務操作日誌審計監督系統',
            Summary: '',
            bmc_identifier: '',
            id: '2000001395',
            org_name: '',
            alarmlevel: 5,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP008',
            NodeAlias: '',
            remark: '零信任平臺：',
            type: '1',
            relation: '["code":"APP021","code":"APP016","code":"APP004","code":"APP005","code":"APP015","code":"APP006","code":"APP012","code":"APP013","code":"APP014","code":"APP020","code":"APP007"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '零信任平臺',
            Summary: '',
            bmc_identifier: '',
            id: '2000001396',
            org_name: '',
            alarmlevel: 0,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP009',
            NodeAlias: '',
            remark: '警用證書認證授權系統：',
            type: '1',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '警用證書認證授權系統',
            Summary: '',
            bmc_identifier: '',
            id: '2000001397',
            org_name: '',
            alarmlevel: 5,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP010',
            NodeAlias: '',
            remark: '視頻管理用戶端：',
            type: '1',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '視頻管理用戶端',
            Summary: '',
            alarmList: [
              {
                app_vendor: '恒訊',
                app_name: '視頻管理用戶端',
                node: 'dzmtfwq',
                pcs_name: '警務雲',
                Identifier: 'dzmtfwqzabbixsyslogdproc.num[nginx]Nginx: Process is not running1',
                NodeAlias: '172.17.43.49',
                Summary: 'Nginx: Process is not running, 0',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '氹仔碼頭治安機房',
                LastOccurrence: '2021-05-26 16:08:28'
              },
              {
                app_vendor: '恒訊',
                app_name: '視頻管理用戶端',
                node: 'dzmtfwq',
                pcs_name: '警務雲',
                Identifier: 'dzmtfwqzabbixsyslogdnet.tcp.service[http localhost 80 ]Nginx: Service is down1',
                NodeAlias: '172.17.43.49',
                Summary: 'Nginx: Service is down, Down (0)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '氹仔碼頭治安機房',
                LastOccurrence: '2021-05-26 16:08:25'
              }
            ],
            bmc_identifier: '',
            id: '2000001398',
            org_name: '',
            alarmlevel: 3,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP011',
            NodeAlias: '',
            remark: '文本智慧處理引擎：',
            type: '1',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '文本智慧處理引擎',
            Summary: '',
            alarmList: [
              {
                app_vendor: '極視角',
                app_name: '文本智慧處理引擎',
                node: 'ocrgpu',
                pcs_name: '警務雲',
                Identifier: 'ocrgpuzabbixsyslogddocker.container_info.state.exitcode[ /determined_colden ]Container /determined_colden: Container has been stopped with error code1',
                NodeAlias: '10.99.137.1',
                Summary: 'Container /determined_colden: Container has been stopped with error code, Exit code: 137',
                bmc_identifier: '',
                Severity: '3',
                org_name: '保安部隊事',
                Location: '港珠澳機房',
                LastOccurrence: '2021-08-13 15:12:31'
              },
              {
                app_vendor: '極視角',
                app_name: '文本智慧處理引擎',
                node: 'ocrgpu',
                pcs_name: '警務雲',
                Identifier: 'ocrgpuzabbixsyslogddocker.container_info.state.exitcode[ /lucid_shockley ]Container /lucid_shockley: Container has been stopped with error code1',
                NodeAlias: '10.99.137.1',
                Summary: 'Container /lucid_shockley: Container has been stopped with error code, Exit code: 137',
                bmc_identifier: '',
                Severity: '3',
                org_name: '保安部隊事',
                Location: '港珠澳機房',
                LastOccurrence: '2021-08-13 15:16:41'
              },
              {
                app_vendor: '極視角',
                app_name: '文本智慧處理引擎',
                node: 'ocrgpu',
                pcs_name: '警務雲',
                Identifier: 'ocrgpuzabbixsyslogddocker.container_info.state.exitcode[ /elegant_keldysh ]Container /elegant_keldysh: Container has been stopped with error code1',
                NodeAlias: '10.99.137.1',
                Summary: 'Container /elegant_keldysh: Container has been stopped with error code, Exit code: 137',
                bmc_identifier: '',
                Severity: '3',
                org_name: '保安部隊事',
                Location: '港珠澳機房',
                LastOccurrence: '2021-08-13 15:15:14'
              },
              {
                app_vendor: '極視角',
                app_name: '文本智慧處理引擎',
                node: 'ocrgpu',
                pcs_name: '警務雲',
                Identifier: 'ocrgpuzabbixsyslogddocker.container_info.state.exitcode[ /festive_kepler ]Container /festive_kepler: Container has been stopped with error code1',
                NodeAlias: '10.99.137.1',
                Summary: 'Container /festive_kepler: Container has been stopped with error code, Exit code: 137',
                bmc_identifier: '',
                Severity: '3',
                org_name: '保安部隊事',
                Location: '港珠澳機房',
                LastOccurrence: '2021-08-13 15:15:27'
              },
              {
                app_vendor: '',
                app_name: '文本智慧處理引擎',
                node: 'jsj-ocr-vm-a001',
                pcs_name: '大腦雲',
                Identifier: 'jsj-ocr-vm-a001zabbixsyslogdredis.info[ tcp://localhost:6379 ]Redis: Failed to fetch info data (or no data for 30m)1',
                NodeAlias: '10.99.137.10',
                Summary: 'Redis: Failed to fetch info data (or no data for 30m), *UNKNOWN*',
                bmc_identifier: '',
                Severity: '3',
                org_name: '保安部隊事務局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-16 16:26:02'
              },
              {
                app_vendor: '',
                app_name: '文本智慧處理引擎',
                node: 'jsj-ocr-vm-a001',
                pcs_name: '大腦雲',
                Identifier: 'jsj-ocr-vm-a001zabbixsyslogdredis.ping[ tcp://localhost:6379 ]Redis: Service is down1',
                NodeAlias: '10.99.137.10',
                Summary: 'Redis: Service is down, Down (0)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '保安部隊事務局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-16 16:52:26'
              },
              {
                app_vendor: '極視角',
                app_name: '文本智慧處理引擎',
                node: 'ocrgpu',
                pcs_name: '警務雲',
                Identifier: 'ocrgpuzabbixsyslogddocker.container_info.state.exitcode[ /serene_leavitt ]Container /serene_leavitt: Container has been stopped with error code1',
                NodeAlias: '10.99.137.1',
                Summary: 'Container /serene_leavitt: Container has been stopped with error code, Exit code: 137',
                bmc_identifier: '',
                Severity: '3',
                org_name: '保安部隊事',
                Location: '港珠澳機房',
                LastOccurrence: '2021-08-13 15:14:45'
              },
              {
                app_vendor: '極視角',
                app_name: '文本智慧處理引擎',
                node: 'ocrgpu',
                pcs_name: '警務雲',
                Identifier: 'ocrgpuzabbixsyslogddocker.container_info.state.exitcode[ /frosty_driscoll ]Container /frosty_driscoll: Container has been stopped with error code1',
                NodeAlias: '10.99.137.1',
                Summary: 'Container /frosty_driscoll: Container has been stopped with error code, Exit code: 137',
                bmc_identifier: '',
                Severity: '3',
                org_name: '保安部隊事',
                Location: '港珠澳機房',
                LastOccurrence: '2021-08-13 15:16:53'
              },
              {
                app_vendor: '極視角',
                app_name: '文本智慧處理引擎',
                node: 'ocrgpu',
                pcs_name: '警務雲',
                Identifier: 'ocrgpuzabbixsyslogddocker.container_info.state.exitcode[ /zealous_babbage ]Container /zealous_babbage: Container has been stopped with error code1',
                NodeAlias: '10.99.137.1',
                Summary: 'Container /zealous_babbage: Container has been stopped with error code, Exit code: 137',
                bmc_identifier: '',
                Severity: '3',
                org_name: '保安部隊事',
                Location: '港珠澳機房',
                LastOccurrence: '2021-08-13 15:14:59'
              }
            ],
            bmc_identifier: '',
            id: '2000001399',
            org_name: '',
            alarmlevel: 3,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP012',
            NodeAlias: '',
            remark: '指揮中心綜合調度系統：',
            type: '1',
            relation: '["code":"APP002","code":"APP008","code":"APP021","code":"APP003","code":"APP007","code":"APP013","code":"APP020"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '指揮中心綜合調度系統',
            Summary: '',
            bmc_identifier: '',
            id: '2000001400',
            org_name: '',
            alarmlevel: 0,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP013',
            NodeAlias: '',
            remark: '智慧消防可視化業務管理系統：',
            type: '1',
            relation: '["code":"APP002","code":"APP008","code":"APP021","code":"APP003","code":"APP007","code":"APP012"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '智慧消防可視化業務管理系統',
            Summary: '',
            bmc_identifier: '',
            id: '2000001401',
            org_name: '',
            alarmlevel: 0,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP014',
            NodeAlias: '',
            remark: '低窪地區疏散撤離管理系統：',
            type: '1',
            relation: '["code":"APP002","code":"APP021","code":"APP003","code":"APP007","code":"APP012"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '低窪地區疏散撤離管理系統',
            Summary: '',
            bmc_identifier: '',
            id: '2000001402',
            org_name: '',
            alarmlevel: 0,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP015',
            NodeAlias: '',
            remark: '刑偵綜合管理系統：',
            type: '1',
            relation: '["code":"APP021","code":"APP007","code":"APP008","code":"APP006"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '刑偵綜合管理系統',
            Summary: '',
            bmc_identifier: '',
            id: '2000001403',
            org_name: '',
            alarmlevel: 5,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP016',
            NodeAlias: '',
            remark: '智慧統計：',
            type: '1',
            relation: '["code":"APP021","code":"APP007","code":"APP008","code":"APP006","code":"APP002","code":"APP020"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '智慧統計',
            Summary: '',
            alarmList: [
              {
                app_vendor: '',
                app_name: '智慧統計',
                node: 'mc-zhtj-vm-a004',
                pcs_name: '大腦雲',
                Identifier: 'mc-zhtj-vm-a004zabbixsyslogdsystem.localtimeSystem time is out of sync (diff with Zabbix server > 60s)1',
                NodeAlias: '10.99.17.25',
                Summary: 'System time is out of sync (diff with Zabbix server > 60s), 2021.09.22 10:11:58',
                bmc_identifier: '',
                Severity: '3',
                org_name: '警察總局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-22 10:13:00'
              }
            ],
            bmc_identifier: '',
            id: '2000001404',
            org_name: '',
            alarmlevel: 3,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP017',
            NodeAlias: '',
            remark: '保安部隊高等學校智慧化建設：',
            type: '1',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '保安部隊高等學校智慧化建設',
            Summary: '',
            bmc_identifier: '',
            id: '2000001405',
            org_name: '',
            alarmlevel: 0,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP018',
            NodeAlias: '',
            remark: '重點區域人潮管控系統：',
            type: '1',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '重點區域人潮管控系統',
            Summary: '',
            alarmList: [
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-UD8PPVQNQQ6',
                pcs_name: '警務雲',
                Identifier: 'WIN-UD8PPVQNQQ6zabbixsyslogdservice.info[ WbioSrvc state] WbioSrvc (Windows Biometric Service) is not running (startup type automatic)1',
                NodeAlias: '192.168.63.105',
                Summary: ' WbioSrvc (Windows Biometric Service) is not running (startup type automatic), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-07-26 18:40:38'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-135BAEKJ96N',
                pcs_name: '警務雲',
                Identifier: 'WIN-135BAEKJ96Nzabbixsyslogdservice.info[ stisvc state] stisvc (Windows Image Acquisition (WIA)) is not running (startup type automatic)1',
                NodeAlias: '192.168.63.106',
                Summary: ' stisvc (Windows Image Acquisition (WIA)) is not running (startup type automatic), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-06-21 10:42:47'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'newlan-vm-0001',
                pcs_name: '大腦雲',
                Identifier: 'newlan-vm-0001zabbixsyslogdservice.info[ WbioSrvc state] WbioSrvc (Windows Biometric Service) is not running (startup type automatic)1',
                NodeAlias: '10.99.192.1',
                Summary: ' WbioSrvc (Windows Biometric Service) is not running (startup type automatic), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-07-26 18:10:06'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'XLzjsjkfwq',
                pcs_name: '警務雲',
                Identifier: 'XLzjsjkfwqzabbixsyslogdservice.info[ OneSyncSvc_25c572ec state] OneSyncSvc_25c572ec (Sync Host_25c572ec) is not running (startup type automatic delayed)1',
                NodeAlias: '192.168.63.138',
                Summary: ' OneSyncSvc_25c572ec (Sync Host_25c572ec) is not running (startup type automatic delayed), No such service (255)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-08-11 23:02:19'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-135BAEKJ96N',
                pcs_name: '警務雲',
                Identifier: 'WIN-135BAEKJ96Nzabbixsyslogdservice.info[ WbioSrvc state] WbioSrvc (Windows Biometric Service) is not running (startup type automatic)1',
                NodeAlias: '192.168.63.106',
                Summary: ' WbioSrvc (Windows Biometric Service) is not running (startup type automatic), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-09-10 21:04:03'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-LAISTU6SNE1',
                pcs_name: '大腦雲',
                Identifier: 'WIN-LAISTU6SNE1zabbixsyslogdservice.info[ WbioSrvc state] WbioSrvc (Windows Biometric Service) is not running (startup type automatic)1',
                NodeAlias: '10.99.17.70',
                Summary: ' WbioSrvc (Windows Biometric Service) is not running (startup type automatic), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-07-26 18:39:13'
              },
              {
                app_vendor: '',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-LAISTU6SNE1',
                pcs_name: '大腦雲',
                Identifier: 'WIN-LAISTU6SNE1zabbixsyslogdservice.info[ BITS state] BITS (Background Intelligent Transfer Service) is not running (startup type automatic delayed)1',
                NodeAlias: '10.99.17.70',
                Summary: ' BITS (Background Intelligent Transfer Service) is not running (startup type automatic delayed), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-21 18:16:08'
              },
              {
                app_vendor: '',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-UD8PPVQNQQ6',
                pcs_name: '大腦雲',
                Identifier: 'WIN-UD8PPVQNQQ6zabbixsyslogdperf_counter_en[ \\PhysicalDisk(0 C:)\\% Disk Time 60]0 C:: Disk is overloaded (util > 95% for 15m)1',
                NodeAlias: '192.168.63.105',
                Summary: '0 C:: Disk is overloaded (util > 95% for 15m), 132.6 %',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-21 01:32:55'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'newlan-G560-V5',
                pcs_name: '警務雲',
                Identifier: 'newlan-G560-V5zabbixsyslogdsystem.localtimeDiff with Zabbix server > 60s1',
                NodeAlias: '10.99.192.7',
                Summary: 'Diff with Zabbix server > 60s, System time is out of sync',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-07-27 03:31:33'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-UD8PPVQNQQ6',
                pcs_name: '警務雲',
                Identifier: 'WIN-UD8PPVQNQQ6zabbixsyslogdservice.info[ OneSyncSvc_5acd6 state] OneSyncSvc_5acd6 (Sync Host_5acd6) is not running (startup type automatic delayed)1',
                NodeAlias: '192.168.63.105',
                Summary: ' OneSyncSvc_5acd6 (Sync Host_5acd6) is not running (startup type automatic delayed), No such service (255)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-07-24 19:33:21'
              },
              {
                app_vendor: '',
                app_name: '重點區域人潮管控系統',
                node: 'XLzjsjkfwq',
                pcs_name: '大腦雲',
                Identifier: 'XLzjsjkfwqzabbixsyslogdmysql.buffer_pool_utilizationMySQL: Buffer pool utilization is too low (less 50% for 5m)1',
                NodeAlias: '192.168.63.138',
                Summary: 'MySQL: Buffer pool utilization is too low (less 50% for 5m), 48.83 %',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-22 10:28:51'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'newlan-vm-0002',
                pcs_name: '大腦雲',
                Identifier: 'newlan-vm-0002zabbixsyslogdservice.info[ WbioSrvc state] WbioSrvc (Windows Biometric Service) is not running (startup type automatic)1',
                NodeAlias: '10.99.192.2',
                Summary: ' WbioSrvc (Windows Biometric Service) is not running (startup type automatic), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-08-01 19:35:13'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-135BAEKJ96N',
                pcs_name: '警務雲',
                Identifier: 'WIN-135BAEKJ96Nzabbixsyslogdsystem.localtimeDdiff with Zabbix server > 60s1',
                NodeAlias: '192.168.63.106',
                Summary: 'Ddiff with Zabbix server > 60s, System time is out of sync',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-06-19 00:00:56'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-135BAEKJ96N',
                pcs_name: '警務雲',
                Identifier: 'WIN-135BAEKJ96Nzabbixsyslogdproc.num[nginx]Nginx: Process is not running1',
                NodeAlias: '192.168.63.106',
                Summary: 'Nginx: Process is not running, 0',
                bmc_identifier: '',
                Severity: '3',
                org_name: '',
                Location: '',
                LastOccurrence: '2021-04-16 13:40:36'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-LAISTU6SNE2',
                pcs_name: '大腦雲',
                Identifier: 'WIN-LAISTU6SNE2zabbixsyslogdservice.info[ WbioSrvc state] WbioSrvc (Windows Biometric Service) is not running (startup type automatic)1',
                NodeAlias: '10.99.17.71',
                Summary: ' WbioSrvc (Windows Biometric Service) is not running (startup type automatic), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-07-26 18:34:24'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'XLzjsjkfwq',
                pcs_name: '警務雲',
                Identifier: 'XLzjsjkfwqzabbixsyslogdservice.info[ WbioSrvc state] WbioSrvc (Windows Biometric Service) is not running (startup type automatic)1',
                NodeAlias: '192.168.63.138',
                Summary: ' WbioSrvc (Windows Biometric Service) is not running (startup type automatic), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-08-11 23:06:12'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-6MP6TNAOKT7',
                pcs_name: '警務雲',
                Identifier: 'WIN-6MP6TNAOKT7zabbixsyslogdservice.info[ WbioSrvc state] WbioSrvc (Windows Biometric Service) is not running (startup type automatic)1',
                NodeAlias: '192.168.63.107',
                Summary: ' WbioSrvc (Windows Biometric Service) is not running (startup type automatic), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-08-31 12:46:11'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'XLzjsjkfwq',
                pcs_name: '警務雲',
                Identifier: 'XLzjsjkfwqzabbixsyslogdsystem.localtimeDdiff with Zabbix server > 60s1',
                NodeAlias: '192.168.63.138',
                Summary: 'Ddiff with Zabbix server > 60s, System time is out of sync',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-07-21 20:44:28'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-UD8PPVQNQQ6',
                pcs_name: '警務雲',
                Identifier: 'WIN-UD8PPVQNQQ6zabbixsyslogdservice.info[ OneSyncSvc_4e3f4 state] OneSyncSvc_4e3f4 (Sync Host_4e3f4) is not running (startup type automatic delayed)1',
                NodeAlias: '192.168.63.105',
                Summary: ' OneSyncSvc_4e3f4 (Sync Host_4e3f4) is not running (startup type automatic delayed), No such service (255)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-07-24 19:11:48'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-6MP6TNAOKT7',
                pcs_name: '警務雲',
                Identifier: 'WIN-6MP6TNAOKT7zabbixsyslogdproc.num[java.exe]Tomcat : At least one java process is not running1',
                NodeAlias: '192.168.63.107',
                Summary: 'Tomcat : At least one java process is not running, 0',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-07-24 19:38:42'
              },
              {
                app_vendor: '',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-LAISTU6SNE2',
                pcs_name: '大腦雲',
                Identifier: 'WIN-LAISTU6SNE2zabbixsyslogdservice.info[ BITS state] BITS (Background Intelligent Transfer Service) is not running (startup type automatic delayed)1',
                NodeAlias: '10.99.17.71',
                Summary: ' BITS (Background Intelligent Transfer Service) is not running (startup type automatic delayed), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-21 14:42:08'
              },
              {
                app_vendor: '新聯偉訊',
                app_name: '重點區域人潮管控系統',
                node: 'WIN-LAISTU6SNE3',
                pcs_name: '大腦雲',
                Identifier: 'WIN-LAISTU6SNE3zabbixsyslogdservice.info[ WbioSrvc state] WbioSrvc (Windows Biometric Service) is not running (startup type automatic)1',
                NodeAlias: '10.99.17.72',
                Summary: ' WbioSrvc (Windows Biometric Service) is not running (startup type automatic), Stopped (6)',
                bmc_identifier: '',
                Severity: '3',
                org_name: '治安警察局',
                Location: '港珠澳機房',
                LastOccurrence: '2021-07-26 18:37:57'
              }
            ],
            bmc_identifier: '',
            id: '2000001406',
            org_name: '',
            alarmlevel: 3,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP019',
            NodeAlias: '',
            remark: '警務微信：',
            type: '1',
            relation: '["code":"APP020"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '警務微信',
            Summary: '',
            alarmList: [
              {
                app_vendor: '',
                app_name: '警務微信',
                node: 'dy-yy-0001',
                pcs_name: '大腦雲',
                Identifier: 'dy-yy-0001zabbixsyslogdproc.num[nginx]Nginx: Process is not running1',
                NodeAlias: '10.99.160.76',
                Summary: 'Nginx: Process is not running, 0',
                bmc_identifier: '000000000000851',
                Severity: '5',
                org_name: '警察總局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-16 13:48:41'
              },
              {
                app_vendor: '',
                app_name: '警務微信',
                node: 'dy-yy-0001',
                pcs_name: '大腦雲',
                Identifier: 'dy-yy-0001zabbixsyslogdproc.num[java root tomcat]Tomcat : tomcat process is not running1',
                NodeAlias: '10.99.160.76',
                Summary: 'Tomcat : tomcat process is not running, 0',
                bmc_identifier: 'CREATION_FAILURE',
                Severity: '5',
                org_name: '警察總局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-16 13:48:53'
              }
            ],
            bmc_identifier: '',
            id: '2000001407',
            org_name: '',
            alarmlevel: 5,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP020',
            NodeAlias: '',
            remark: '惠民服務：',
            type: '1',
            relation: '["code":"APP007","code":"APP002","code":"APP008","code":"APP019","code":"APP021","code":"APP012","code":"APP016"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '惠民服務',
            Summary: '',
            bmc_identifier: '',
            id: '2000001408',
            org_name: '',
            alarmlevel: 0,
            Location: '',
            LastOccurrence: ''
          },
          {
            code: 'APP021',
            NodeAlias: '',
            remark: '警務綜合管理系統：',
            type: '1',
            relation: '["code":"APP007","code":"APP016","code":"APP004","code":"APP005","code":"APP015","code":"APP006","code":"APP012","code":"APP013","code":"APP014","code":"APP003","code":"APP020","code":"APP008"]',
            app_vendor: '',
            app_name: '',
            node: '',
            pcs_name: '',
            Identifier: '',
            name: '警務綜合管理系統',
            Summary: '',
            alarmList: [
              {
                app_vendor: '',
                app_name: '警務綜合管理系統',
                node: 'mc-jwzh-vm-a006',
                pcs_name: '大腦雲',
                Identifier: 'mc-jwzh-vm-a006zabbixsyslogdsystem.localtimeSystem time is out of sync (diff with Zabbix server > 60s)1',
                NodeAlias: '10.99.17.7',
                Summary: 'System time is out of sync (diff with Zabbix server > 60s), 2021.09.22 10:04:37',
                bmc_identifier: '000000000000843',
                Severity: '3',
                org_name: '警察總局',
                Location: '港珠澳數據中心機房',
                LastOccurrence: '2021-09-22 10:05:40'
              }
            ],
            bmc_identifier: '',
            id: '2000001409',
            org_name: '',
            alarmlevel: 5,
            Location: '',
            LastOccurrence: ''
          }
        ],
        status: 1
      }
      if (redata.code === 101) {
        console.log(redata.message)
      } else if (redata.code === 8000) {
        this.getData(redata.message)
      } else {
        alert(redata.message)
      }
    },
    websocketsend (Data) { // 数据发送
      this.websock.send(Data)
    },
    websocketclose (e) { // 关闭
      console.log('断开连接', e)
    },
    // 设置点线
    setlineCoord (data) {
      const coords = []
      // 目标点
      if (data.tagrat) {
        const column = estimateColumn(data.tagrat, this.appGroups)
        // 右侧
        if (column === 0) {
          coords.push({
            coords: allLine[data.tagrat].r1
          })
          data.relation.forEach(item => {
            coords.push({
              coords: allLine[item].l1 || allLine[item].r1
            })
          })
          // 折线
          const rueslt = managePolyline(data.tagrat, this.appGroups, data.relation, allLine)
          coords.push(...rueslt)
        }
        // 左侧
        if (column === this.appGroups.length - 1) {
          const _allLine = JSON.parse(JSON.stringify(allLine))
          coords.push({
            coords: _allLine[data.tagrat].l1
          })
          data.relation.forEach(item => {
            coords.push({
              coords: _allLine[item].r1 || _allLine[item].l1
            })
          })
          // 折线
          const rueslt = managePolyline(data.tagrat, this.appGroups, data.relation, _allLine)
          coords.push(...rueslt)
        }
        // 中间
        if (column === 1 || column === 2) {
          const _allLine = JSON.parse(JSON.stringify(allLine))
          const orientation = hasRelationOrientation(data.tagrat, this.appGroups, data.relation)
          if (orientation.length) {
            orientation.forEach(item => {
              coords.push({
                coords: allLine[data.tagrat][item]
              })
            })
          } else {
            coords.push({
              coords: allLine[data.tagrat].l1
            })
          }
          // 第二列
          if (column === 1) {
            const interLeft = intersectionArr(this.appGroups[0], data.relation)
            interLeft.forEach(item => {
              coords.push({
                coords: allLine[item].r1
              })
            })
            const interRight = intersectionArr([...this.appGroups[2], ...this.appGroups[3]], data.relation)
            interRight.forEach(item => {
              coords.push({
                coords: allLine[item].l1
              })
            })
          }
          // 第三列
          if (column === 2) {
            const interLeft = intersectionArr([...this.appGroups[0], ...this.appGroups[1]], data.relation)
            interLeft.forEach(item => {
              coords.push({
                coords: allLine[item].r1
              })
            })
            const interRight = intersectionArr(this.appGroups[3], data.relation)
            interRight.forEach(item => {
              coords.push({
                coords: allLine[item].l1
              })
            })
          }

          // 在本列的app
          const interColumn = intersectionArr(this.appGroups[column], data.relation)
          interColumn.forEach(item => {
            coords.push({
              coords: allLine[item].l1
            })
          })

          // 折线
          const rueslt = managePolyline(data.tagrat, this.appGroups, data.relation, _allLine)
          coords.push(...rueslt)
        }
      }

      function mangerdistance (to, from) {
        if (Math.abs(to[0] - from[0]) < 50 && Math.abs(to[1] - from[1]) < 50) {
          return false
        }
        return true
      }
      lineOption.series = coords.map(item => {
        return {
          type: 'lines',
          polyline: true,
          coordinateSystem: 'cartesian2d',
          lineStyle: {
            // type: [8, 4],
            width: 3,
            color: 'rgba(0, 197, 255, 1)',
            opacity: 0.95
          },
          effect: {
            show: mangerdistance(item.coords[0], item.coords[1]),
            constantSpeed: 150,
            trailLength: 0,
            symbol: 'image://http://app.liuhuanhong.com/assets/img_lightspot_b.png',
            // symbol: 'circle',
            symbolSize: 40,
            color: '#40DDBF'
          },
          data: [item]
        }
      })
      console.log(lineOption)
      this.lineOption = lineOption
    }
  },
  watch: {
    $route: {
      handler (route) {
        this.$nextTick(() => {
          this.websocketonmessage()
          if (route.query.iframe) {
            this.iframe = route.query.iframe
          }
          if (route.query.userid) {
            this.userId = route.query.userid
            // this.initWebSocket()
          } else {
            // this.$message({
            //   message: 'userid参数错误',
            //   type: 'error'
            // })
          }
        })
      },
      immediate: true
    },
    relationApp: {
      handler (data) {
        if (data.tagrat) {
          this.showModal = true
          if (data.relation.length) {
            this.setlineCoord(data)
            // this.addAnimation = true
          } else {
            // 其他隐藏

          }
          // this.lineOption = lineOption
        } else {
          this.showModal = false
          this.lineOption = {}
          this.addAnimation = false
        }
      },
      deep: true
    }
  }
}
</script>
